const routes = [
  /* -------------------------------------------------------------------------- */
  /*                                 Main Layout                                */
  /* -------------------------------------------------------------------------- */
  {
    path: '/',
    component: () => import('layouts/LayoutWrapper.vue'),
    children: [
      /* -------------------------------- Dashboard ------------------------------- */
      {
        path: '',
        name: 'Dashboard',
        component: () => import('src/pages/Dashboard/Dashboard.vue'),
        meta: { sidebar: { category: 'dashboard', route_name: 'Dashboard' }, useNoZoomLayout: true },
      },
      /* --------------------------------- Account -------------------------------- */
      {
        path: 'account',
        name: 'Account',
        meta: { access: [17] },
        children: [
          {
            path: 'overview',
            name: 'AccountOverview',
            component: () => import('src/pages/ManageAccount/AccountPlans/AccountOverview/AccountOverview.vue'),
            meta: { access: [17], sidebar: { category: 'account', route_name: 'AccountOverview' } },
          },
          {
            path: 'edit',
            name: 'AccountEntity',
            component: () => import('src/pages/ManageAccount/AccountPlans/AccountEntity/AccountEntity.vue'),
            meta: { access: [17], sidebar: { category: 'account', route_name: 'AccountOverview' } },
          },
          {
            path: 'subscription',
            name: 'SubscriptionTiers',
            component: () => import('src/pages/ManageAccount/AccountPlans/SubscriptionTiers/SubscriptionTiers.vue'),
            meta: { access: [17], sidebar: { category: 'account', route_name: 'AccountOverview' } },
          },
          {
            path: 'branch/list',
            name: 'BranchList',
            component: () => import('src/pages/Branches/List/BranchList.vue'),
            props: true,
            meta: {
              access: [17],
              useNoZoomLayout: true,
              sidebar: { category: 'account', route_name: 'BranchList' },
            },
          },
          {
            path: 'branch/branch-entity/:id',
            name: 'BranchEntity',
            component: () => import('src/pages/Branches/Entity/BranchEntity.vue'),
            props: true,
            meta: {
              access: [17],
              useNoZoomLayout: true,
              sidebar: { category: 'account', route_name: 'BranchList' },
            },
          },
        ],
      },
      /* -------------------------------- Inventory ------------------------------- */
      {
        path: 'inventory',
        name: 'Inventory',
        meta: { access: [1, 2, 3, 4] },
        children: [
          // Category
          {
            path: 'category',
            children: [
              {
                path: 'category-entity/:id',
                name: 'CategoryEntity',
                component: () => import('src/pages/Inventory/Category/CategoryEntity/CategoryEntity.vue'),
                props: true,
                meta: { useNoZoomLayout: true, sidebar: { category: 'inventory', route_name: 'ItemLibrary' } },
              },
            ],
          },
          // Item
          {
            path: 'item',
            children: [
              {
                path: 'item-library/:categoryId',
                name: 'ItemLibrary',
                component: () => import('src/pages/Inventory/Item/ItemLibrary/ItemLibrary.vue'),
                props: true,
                meta: {
                  access: [1],
                  useNoZoomLayout: true,
                  sidebar: { category: 'inventory', route_name: 'ItemLibrary' },
                },
              },
              {
                path: 'item-entity/:id/:categoryId',
                name: 'ItemEntity',
                component: () => import('src/pages/Inventory/Item/ItemEntity/ItemEntity.vue'),
                props: true,
                meta: { useNoZoomLayout: true, sidebar: { category: 'inventory', route_name: 'ItemLibrary' } },
              },
              {
                path: 'import-csv',
                name: 'ImportCSV',
                component: () => import('src/pages/Inventory/Item/ImportCSV/ImportCSV.vue'),
                meta: { useNoZoomLayout: true, sidebar: { category: 'inventory', route_name: 'ImportCSV' } },
              },
              {
                path: 'translation',
                name: 'ItemsTranslation',
                component: () => import('src/pages/Inventory/Item/ItemsTranslation/ItemsTranslation.vue'),
                meta: { useNoZoomLayout: true, sidebar: { category: 'inventory', route_name: 'ItemsTranslation' } },
              },
            ],
          },
          // Stock Control
          {
            path: 'modifier',
            name: 'ModifierList',
            component: () => import('src/pages/Inventory/Modifier/ModifierList/ModifierList.vue'),
            meta: {
              access: [2],
              useNoZoomLayout: true,
              sidebar: { category: 'inventory', route_name: 'ModifierList' },
            },
          },
          {
            path: 'modifier-entity',
            children: [
              {
                path: 'modifier-entity/:id',
                name: 'ModifierEntity',
                component: () => import('src/pages/Inventory/Modifier/ModifierEntity/ModifierEntity.vue'),
                props: true,
                meta: {
                  access: [2],
                  useNoZoomLayout: true,
                  sidebar: { category: 'inventory', route_name: 'ModifierList' },
                },
              },
            ],
          },
        ],
      },
      /* ------------------------------ Stock Control ----------------------------- */
      {
        path: 'stock-control',
        name: 'StockControl',
        meta: { access: [35, 36, 37], useNoZoomLayout: true },
        children: [
          // Category
          {
            path: 'stock-level',
            name: 'StockLevel',
            component: () => import('src/pages/Inventory/Stock/Stock.vue'),
            meta: {
              access: [3],
              useNoZoomLayout: true,
              sidebar: { category: 'stock_control', route_name: 'StockLevel' },
            },
          },
          {
            path: 'suppliers',
            children: [
              {
                path: '',
                name: 'SupplierList',
                component: () => import('src/pages/StockControl/Suppliers/SupplierList/SupplierList.vue'),
                meta: { access: [36], sidebar: { category: 'stock_control', route_name: 'SupplierList' } },
              },
              {
                path: ':id',
                name: 'SupplierEntity',
                component: () => import('src/pages/StockControl/Suppliers/SupplierEntity/SupplierEntity.vue'),
                meta: { access: [36], sidebar: { category: 'stock_control', route_name: 'SupplierList' } },
                props: true,
              },
            ],
          },
          {
            path: 'stock-take',
            children: [
              {
                path: '',
                name: 'StockTakeList',
                component: () => import('src/pages/StockControl/StockTake/StockTakeList/StockTakeList.vue'),
                meta: { access: [37], sidebar: { category: 'stock_control', route_name: 'StockTakeList' } },
              },
              {
                path: ':storeId/:id',
                name: 'StockTakeEntity',
                component: () => import('src/pages/StockControl/StockTake/StockTakeEntity/StockTakeEntity.vue'),
                meta: { access: [37], sidebar: { category: 'stock_control', route_name: 'StockTakeList' } },
                props: true,
              },
            ],
          },

          {
            path: 'purchase-orders',

            children: [
              {
                path: '',
                name: 'StockControlPurchaseOrders',
                component: () => import('src/pages/StockControl/PurchaseOrders/List/PurchaseOrdersList.vue'),
                meta: {
                  access: [35],
                  sidebar: { category: 'stock_control', route_name: 'StockControlPurchaseOrders' },
                },
              },
              {
                path: ':id',
                name: 'StockControlPurchaseOrdersEntity',
                component: () => import('src/pages/StockControl/PurchaseOrders/Entity/PurchaseOrdersEntity.vue'),
                meta: {
                  access: [35],
                  sidebar: { category: 'stock_control', route_name: 'StockControlPurchaseOrders' },
                },
                props: true,
              },
            ],
          },

          {
            path: 'ai-insights-stock',
            children: [
              {
                path: '',
                name: 'StockControlAiInsightsStock',
                component: () => import('src/pages/StockControl/AiInsightsStock/AiInsightsStock.vue'),
                meta: { sidebar: { category: 'stock_control', route_name: 'StockControlAiInsightsStock' } },
              },
            ],
          },
        ],
      },
      /* ---------------------------------- Staff --------------------------------- */
      {
        path: 'staff',
        name: 'Staff',
        meta: { access: [7] },
        children: [
          // List
          {
            path: 'list',
            name: 'StaffList',
            component: () => import('src/pages/Staff/List/StaffList.vue'),
            meta: { access: [7], useNoZoomLayout: true, sidebar: { category: 'staff', route_name: 'StaffList' } },
          },
          // Entity
          {
            path: 'staff-entity/:id',
            name: 'StaffEntity',
            component: () => import('src/pages/Staff/Entity/StaffEntity.vue'),
            props: true,
            meta: { access: [7], useNoZoomLayout: true, sidebar: { category: 'staff', route_name: 'StaffList' } },
          },
          // Time Clock
          {
            path: 'time-clock',
            name: 'StaffTimeClock',
            component: () => import('src/pages/Staff/TimeClock/StaffTimeClock.vue'),
            meta: { access: [7], useNoZoomLayout: true, sidebar: { category: 'staff', route_name: 'StaffTimeClock' } },
          },
          {
            path: 'time-sheets',
            name: 'StaffTimeSheets',
            component: () => import('src/pages/Staff/Timesheets/StaffTimesheets.vue'),
            meta: { access: [7], sidebar: { category: 'staff', route_name: 'StaffTimeSheets' } },
          },

          {
            path: 'ai-insights-staff',
            children: [
              {
                path: '',
                name: 'StaffAiInsightsStaff',
                component: () => import('src/pages/Staff/AiInsightsStaff/AiInsightsStaff.vue'),
                meta: { sidebar: { category: 'staff', route_name: 'StaffAiInsightsStaff' } },
              },
            ],
          },
        ],
      },
      /* -------------------------------- Customers ------------------------------- */
      {
        path: 'customers',
        name: 'Customers',
        meta: { access: [8], useNoZoomLayout: true },
        children: [
          {
            path: 'list',
            name: 'CustomersList',
            component: () => import('src/pages/Customers/List/CustomersList.vue'),
            meta: { access: [8], sidebar: { category: 'customers', route_name: 'CustomersList' } },
          },
          {
            path: 'customer-entity/:id',
            name: 'CustomerEntity',
            component: () => import('src/pages/Customers/Entity/CustomerEntity.vue'),
            props: true,
            meta: { sidebar: { category: 'customers', route_name: 'CustomersList' } },
          },
        ],
      },
      /* -------------------------------- Marketing ------------------------------- */
      {
        path: 'marketing',
        name: 'Marketing',
        meta: { access: [4, 40], useNoZoomLayout: true },
        children: [
          // Discount
          {
            path: 'promotion',
            name: 'DiscountList',
            component: () => import('src/pages/Inventory/Discount/DiscountList/DiscountList.vue'),
            meta: { access: [4], sidebar: { category: 'marketing', route_name: 'DiscountList' } },
          },
          // Discount Entity
          {
            path: 'promotion/:id',
            name: 'DiscountEntity',
            component: () => import('src/pages/Inventory/Discount/DiscountEntity/DiscountEntity.vue'),
            props: true,
            meta: { access: [4], sidebar: { category: 'marketing', route_name: 'DiscountList' } },
          },
          {
            path: 'gift-card',
            name: 'GiftCardList',
            component: () => import('src/pages/Marketing/GiftCard/GiftCardList/GiftCardList.vue'),
            meta: { access: [40], sidebar: { category: 'marketing', route_name: 'GiftCardList' } },
          },
          {
            path: 'gift-card/:id',
            name: 'GiftCardEntity',
            component: () => import('src/pages/Marketing/GiftCard/GiftCardEntity/GiftCardEntity.vue'),
            props: true,
            meta: { access: [40], sidebar: { category: 'marketing', route_name: 'GiftCardList' } },
          },
          {
            path: 'issued-gift-card',
            name: 'IssuedGiftCardList',
            component: () => import('src/pages/Marketing/IssuedGiftCard/IssuedGiftCardList/IssuedGiftCardList.vue'),
            meta: { access: [40], sidebar: { category: 'marketing', route_name: 'IssuedGiftCardList' } },
          },
        ],
      },
      /* --------------------------------- Orders --------------------------------- */
      {
        path: 'orders',
        name: 'Orders',
        meta: { access: [9, 10], useNoZoomLayout: true },
        children: [
          {
            path: 'active',
            name: 'ActiveOrders',
            component: () => import('src/pages/Orders/ActiveOrders/ActiveOrders.vue'),
            props: true,
            meta: { access: [9], sidebar: { category: 'orders', route_name: 'ActiveOrders' } },
          },
          {
            path: 'complete',
            name: 'CompleteOrders',
            component: () => import('src/pages/Orders/CompleteOrders/CompleteOrders.vue'),
            props: true,
            meta: { access: [10], sidebar: { category: 'orders', route_name: 'CompleteOrders' } },
          },
        ],
      },
      /* --------------------------------- Apppair -------------------------------- */
      {
        path: 'apppair',
        name: 'AppPair',
        meta: { access: [11], useNoZoomLayout: true },
        children: [
          {
            path: '',
            name: 'ApppairIntegrations',
            component: () => import('src/pages/Apppair/ApppairIntegrations/ApppairIntegrations.vue'),
            meta: { access: [11], sidebar: { category: 'integrations', route_name: 'ApppairIntegrations' } },
          },
          {
            path: 'integrations',
            children: [
              {
                path: 'square',
                name: 'Square',
                meta: { access: [11], sidebar: { category: 'integrations', route_name: 'ApppairIntegrations' } },
                component: () => import('src/pages/Apppair/Integrations/Square/Square.vue'),
              },
              {
                path: 'embargo',
                name: 'Embargo',
                meta: { access: [11], sidebar: { category: 'integrations', route_name: 'ApppairIntegrations' } },
                component: () => import('src/pages/Apppair/Integrations/Embargo/Embargo.vue'),
              },
              {
                path: 'wolt',
                name: 'Wolt',
                meta: { access: [11], sidebar: { category: 'integrations', route_name: 'ApppairIntegrations' } },
                component: () => import('src/pages/Apppair/Integrations/Wolt/Wolt.vue'),
              },
              {
                path: 'bolt',
                name: 'Bolt',
                meta: { access: [11], sidebar: { category: 'integrations', route_name: 'ApppairIntegrations' } },
                component: () => import('src/pages/Apppair/Integrations/Bolt/Bolt.vue'),
              },
              {
                path: 'uber-eats',
                name: 'UberEats',
                meta: { access: [11], sidebar: { category: 'integrations', route_name: 'ApppairIntegrations' } },
                component: () => import('src/pages/Apppair/Integrations/UberEats/UberEats.vue'),
              },
              {
                path: 'deliveroo',
                name: 'Deliveroo',
                meta: { access: [11], sidebar: { category: 'integrations', route_name: 'ApppairIntegrations' } },
                component: () => import('src/pages/Apppair/Integrations/deliveroo/Deliveroo.vue'),
              },
              {
                path: 'epos-now',
                name: 'EposNow',
                meta: { access: [11], sidebar: { category: 'integrations', route_name: 'ApppairIntegrations' } },
                component: () => import('src/pages/Apppair/Integrations/EposNow/EposNow.vue'),
              },
              {
                path: 'goodtill',
                name: 'Goodtill',
                meta: { access: [11], sidebar: { category: 'integrations', route_name: 'ApppairIntegrations' } },
                component: () => import('src/pages/Apppair/Integrations/Goodtill/Goodtill.vue'),
              },
              {
                path: 'lightspeed',
                name: 'Lightspeed',
                meta: { access: [11], sidebar: { category: 'integrations', route_name: 'ApppairIntegrations' } },
                component: () => import('src/pages/Apppair/Integrations/Lightspeed/Lightspeed.vue'),
              },
              {
                path: 'slack',
                name: 'Slack',
                meta: { access: [11], sidebar: { category: 'integrations', route_name: 'ApppairIntegrations' } },
                component: () => import('src/pages/Apppair/Integrations/Slack/Slack.vue'),
              },
              {
                path: 'glovo',
                name: 'Glovo',
                meta: { access: [11], sidebar: { category: 'integrations', route_name: 'ApppairIntegrations' } },
                component: () => import('src/pages/Apppair/Integrations/Glovo/Glovo.vue'),
              },
              {
                path: 'dotypos',
                name: 'Dotypos',
                meta: { access: [11], sidebar: { category: 'integrations', route_name: 'ApppairIntegrations' } },
                component: () => import('src/pages/Apppair/Integrations/Dotypos/Dotypos.vue'),
              },
              {
                path: 'worldpay',
                name: 'WorldPay',
                meta: { access: [11], sidebar: { category: 'integrations', route_name: 'ApppairIntegrations' } },
                component: () => import('src/pages/Apppair/Integrations/WorldPay/WorldPay.vue'),
              },
              {
                path: 'xero',
                name: 'Xero',
                meta: { access: [11], sidebar: { category: 'integrations', route_name: 'ApppairIntegrations' } },
                component: () => import('src/pages/Apppair/Integrations/Xero/Xero.vue'),
              },
              {
                path: 'fourth',
                name: 'Fourth',
                meta: { access: [11], sidebar: { category: 'integrations', route_name: 'ApppairIntegrations' } },
                component: () => import('src/pages/Apppair/Integrations/Fourth/Fourth.vue'),
              },
              {
                path: 'square-payment',
                name: 'SquarePayment',
                meta: { access: [11], sidebar: { category: 'integrations', route_name: 'ApppairIntegrations' } },
                component: () => import('src/pages/Apppair/Integrations/SquarePayment/SquarePayment.vue'),
              },
              {
                path: 'embargo-pay',
                name: 'EmbargoPay',
                meta: { access: [11], sidebar: { category: 'integrations', route_name: 'ApppairIntegrations' } },
                component: () => import('src/pages/Apppair/Integrations/Adyen/Adyen.vue'),
              },
              {
                path: 'just-eat',
                name: 'JustEat',
                meta: { access: [11] },
                component: () => import('src/pages/Apppair/Integrations/JustEat/JustEat.vue'),
              },
              {
                path: 'wealthon',
                name: 'Wealthon',
                meta: { access: [11] },
                component: () => import('src/pages/Apppair/Integrations/Wealthon/Wealthon.vue'),
              },
            ],
          },
        ],
      },
      /* --------------------------------- Accounting -------------------------------- */
      // {
      //   path: 'journals',
      //   name: 'Journals',
      //   meta: { access: [13] },
      //   children: [
      //     {
      //       path: 'journals',
      //       name: 'Journals',
      //       component: () => import('src/pages/Accounting/Journal/Journal.vue'),
      //       meta: { access: [13] }
      //     },
      //     {
      //       path: 'add-journals',
      //       name: 'AddJournals',
      //       component: () =>
      //         import('src/pages/Accounting/AddJournal/AddJournal.vue')
      //     }
      //   ]
      // },

      /* --------------------------------- Accounting -------------------------------- */
      {
        path: 'accounting',
        name: 'Accounting',
        meta: { access: [12, 13] },
        children: [
          {
            path: 'accounting-chart',
            name: 'AccountingChart',
            component: () => import('src/pages/Accounting/AccountingCharts/AccountingCharts.vue'),
            meta: {
              access: [12],
              useNoZoomLayout: true,
              sidebar: { category: 'accounting', route_name: 'AccountingChart' },
            },
          },
          {
            path: 'transactions/:id/:subsidiaryId',
            name: 'AccountingTransactions',
            component: () => import('src/pages/Accounting/AccountingTransactions/AccountingTransactions.vue'),
            props: true,
            meta: { useNoZoomLayout: true, sidebar: { category: 'accounting', route_name: 'AccountingChart' } },
          },
          {
            path: 'cash-flow',
            name: 'AccountingCashFlow',
            component: () => import('src/pages/Accounting/Reports/CashFlow/CashFlow.vue'),
            // FIXME: add correct access here
            meta: {
              access: [12],
              useNoZoomLayout: true,
              sidebar: { category: 'accounting', route_name: 'AccountingCashFlow' },
            },
          },
          {
            path: 'profit-and-loss',
            name: 'AccountingProfitLoss',
            component: () => import('src/pages/Accounting/Reports/ProfitLoss/ProfitLoss.vue'),
            // FIXME: add correct access here
            meta: {
              access: [12],
              useNoZoomLayout: true,
              sidebar: { category: 'accounting', route_name: 'AccountingProfitLoss' },
            },
          },
          {
            path: 'journals',
            name: 'AccountingJournals',
            component: () => import('src/pages/Accounting/AccountingJournals/AccountingJournals.vue'),
            meta: {
              access: [13],
              useNoZoomLayout: true,
              sidebar: { category: 'accounting', route_name: 'AccountingJournals' },
            },
          },
          {
            path: 'journals/add',
            name: 'AddAccountingJournal',
            component: () => import('src/pages/Accounting/AddAccountingJournal/AddAccountingJournal.vue'),
            meta: { useNoZoomLayout: true, sidebar: { category: 'accounting', route_name: 'AccountingJournals' } },
          },
        ],
      },
      /* ---------------------------------- Menu ---------------------------------- */
      {
        path: 'menu',
        name: 'Menu',
        meta: { access: [5, 6] },
        children: [
          {
            path: 'menu-library',
            name: 'MenuLibrary',
            component: () => import('src/pages/Menu/MenuLibrary/MenuLibrary.vue'),
            meta: { access: [5], useNoZoomLayout: true, sidebar: { category: 'menu', route_name: 'MenuLibrary' } },
          },
          {
            path: 'add-item/:menuId',
            name: 'MenuAddItem',
            component: () => import('src/pages/Menu/MenuAddItem/MenuAddItem.vue'),
            props: true,
            meta: { useNoZoomLayout: true, sidebar: { category: 'menu', route_name: 'MenuLibrary' } },
          },
          {
            path: 'manage-availability',
            name: 'MenuManageAvailability',
            component: () => import('src/pages/Menu/ManageAvailability/ManageAvailability.vue'),
            meta: { access: [6], sidebar: { category: 'menu', route_name: 'MenuManageAvailability' } },
          },
          {
            path: 'modifiers',
            name: 'MenuModifiers',
            component: () => import('src/pages/Menu/MenuModifiers/MenuModifiers.vue'),
            meta: { sidebar: { category: 'menu', route_name: 'MenuModifiers' } },
          },
          {
            path: 'menu-entity/:id',
            name: 'MenuEntity',
            component: () => import('src/pages/Menu/MenuEntity/MenuEntity.vue'),
            props: true,
            meta: { useNoZoomLayout: true, sidebar: { category: 'menu', route_name: 'MenuLibrary' } },
          },
          {
            path: 'menu-category-entity/:menuId/:id',
            name: 'MenuCategoryEntity',
            component: () => import('src/pages/Menu/MenuCategoryEntity/MenuCategoryEntity.vue'),
            props: true,
            meta: { useNoZoomLayout: true, sidebar: { category: 'menu', route_name: 'MenuLibrary' } },
          },
        ],
      },
      /* -------------------------------- Settings -------------------------------- */
      // FIXME:@reza
      {
        path: 'settings',
        name: 'Settings',
        meta: { access: [16] },
        children: [
          // System Setting
          {
            path: 'system-settings',
            meta: {
              access: [16],
              useNoZoomLayout: true,
              sidebar: { category: 'settings', route_name: 'SystemSettings' },
            },
            name: 'SystemSettings',
            component: () => import('pages/Settings/SystemSettings/SystemSettings.vue'),
          },
          // Devices & Profiles
          {
            path: 'devices-profiles',
            name: 'DevicesAndProfiles',
            meta: {
              access: [],
              useNoZoomLayout: true,
              sidebar: { category: 'settings', route_name: 'DevicesAndProfiles' },
            },
            component: () => import('pages/Settings/DevicesAndProfiles/DevicesAndProfiles.vue'),
          },
          // General Kiosk Profile
          {
            path: 'devices-profiles/kiosk-setup/general/:id',
            name: 'DevicesAndProfilesKioskSetupGeneral',
            meta: { access: [], sidebar: { category: 'settings', route_name: 'DevicesAndProfiles' } },
            component: () =>
              import('src/pages/Settings/DevicesAndProfiles/KioskProfiles/KioskGeneralSetup/KioskGeneralSetup.vue'),
            props: true,
          },
          // Menu Kiosk Profile
          {
            path: 'devices-profiles/kiosk-setup/menu/:id',
            name: 'DevicesAndProfilesKioskSetupMenu',
            meta: { access: [], sidebar: { category: 'settings', route_name: 'DevicesAndProfiles' } },
            component: () =>
              import('src/pages/Settings/DevicesAndProfiles/KioskProfiles/KioskMenuSetup/KioskMenuSetup.vue'),
            props: true,
          },
          // Table Map Setups Entity
          {
            path: 'devices-profiles/table-map-setups/:id',
            name: 'DevicesAndProfilesTableMapSetupsEntity',
            meta: {
              access: [],
              useNoZoomLayout: true,
              sidebar: { category: 'settings', route_name: 'DevicesAndProfiles' },
            },
            component: () => import('src/pages/Settings/TableMapSetupsEntity/TableMapSetupsEntity.vue'),
            props: true,
          },
          // Table Map Setups Template Entity
          {
            path: 'devices-profiles/table-map-setups/:id/template',
            name: 'DevicesAndProfilesTableMapTemplateEntity',
            meta: {
              access: [],
              useNoZoomLayout: true,
              sidebar: { category: 'settings', route_name: 'DevicesAndProfiles' },
            },
            component: () => import('src/pages/Settings/TableMapTemplateEntity/TableMapTemplateEntity.vue'),
            props: true,
          },
          // POS Profile Entity
          {
            path: 'devices-profiles/pos-profiles/:id',
            name: 'POSProfileEntity',
            meta: { access: [], sidebar: { category: 'settings', route_name: 'DevicesAndProfiles' } },
            component: () => import('src/pages/Settings/POSProfileEntity/POSProfileEntity.vue'),
            props: true,
          },
          // KDS Profile Entity
          {
            path: 'devices-profiles/kds-profiles/:id',
            name: 'KDSProfileEntity',
            meta: { access: [], sidebar: { category: 'settings', route_name: 'DevicesAndProfiles' } },
            component: () => import('src/pages/Settings/KDSProfileEntity/KDSProfileEntity.vue'),
            props: true,
          },
          // Digital Menu Profiles Entity
          {
            path: 'devices-profiles/digital-menu-profiles/:id',
            name: 'DevicesAndProfilesDigitalMenuProfilesEntity',
            meta: { access: [], sidebar: { category: 'settings', route_name: 'DevicesAndProfiles' } },
            component: () => import('src/pages/Settings/DigitalMenuProfilesEntity/DigitalMenuProfilesEntity.vue'),
            props: true,
          },
          // Digital Menu Template Entity
          {
            path: 'devices-profiles/digital-menu-templates/:id',
            name: 'DevicesAndProfilesDigitalMenuTemplatesEntity',
            meta: { access: [], sidebar: { category: 'settings', route_name: 'DevicesAndProfiles' } },
            component: () => import('src/pages/Settings/DigitalMenuTemplatesEntity/DigitalMenuTemplatesEntity.vue'),
          },
          {
            path: 'devices-profiles/order-status-profiles/:id',
            name: 'DevicesAndProfilesOrderStatusProfilesEntity',
            meta: {
              access: [],
              useNoZoomLayout: true,
              sidebar: { category: 'settings', route_name: 'DevicesAndProfiles' },
            },
            component: () => import('src/pages/Settings/OrderStatusProfilesEntity/OrderStatusProfilesEntity.vue'),
            props: true,
          },
          // Printing Setups
          {
            path: 'printing-setups',
            name: 'PrintingSetups',
            meta: {
              access: [],
              useNoZoomLayout: true,
              sidebar: { category: 'settings', route_name: 'PrintingSetups' },
            },
            component: () => import('pages/Settings/PrintingSetups/PrintingSetups.vue'),
          },

          // System Setting
          {
            path: 'receipt-templates',
            meta: { access: [], sidebar: { category: 'settings', route_name: 'PrintingSetups' } },
            name: 'ReceiptTemplates',
            component: () => import('pages/Settings/ReceiptTemplates/ReceiptTemplates.vue'),
          },
          {
            path: 'receipt-templates/:id',
            meta: { access: [], sidebar: { category: 'settings', route_name: 'PrintingSetups' } },
            name: 'PrintingSetupsReceiptTemplatesEntity',
            component: () => import('pages/Settings/ReceiptTemplates/EntityReceiptTemplate/EntityReceiptTemplate.vue'),
          },
          {
            path: 'receipt-text-only/:id',
            meta: {
              access: [],
              useNoZoomLayout: true,
              sidebar: { category: 'settings', route_name: 'PrintingSetups' },
            },
            name: 'PrintingSetupsReceiptTextOnlyEntity',
            component: () => import('pages/Settings/ReceiptTemplates/EntityReceiptTextOnly/EntityReceiptTextOnly.vue'),
            props: true,
          },
          // Archives
          {
            path: 'archives',
            name: 'Archives',
            meta: { access: [], useNoZoomLayout: true, sidebar: { category: 'settings', route_name: 'Archives' } },
            component: () => import('pages/Settings/Archives/Archives.vue'),
          },
        ],
      },

      /* --------------------------------- Report --------------------------------- */
      {
        path: 'report',
        name: 'Report',
        meta: { access: [14] },
        component: () => import('src/layouts/ReportLayout.vue'),
        children: [
          {
            path: 'overview',
            name: 'ReportsOverview',
            component: () => import('src/pages/Report/ReportsOverview/ReportsOverview.vue'),
            meta: {
              access: [29],
              useNoZoomLayout: true,
              sidebar: { category: 'reports', route_name: 'ReportsOverview' },
            },
          },
          {
            path: 'hourly-sales',
            name: 'HourlySales',
            component: () => import('src/pages/Report/HourlySales/HourlySales.vue'),
            meta: { access: [14], useNoZoomLayout: true, sidebar: { category: 'reports', route_name: 'HourlySales' } },
          },
          {
            path: 'daily-sales',
            name: 'DailySales',
            component: () => import('src/pages/Report/DailySales/DailySales.vue'),
            meta: { access: [31], useNoZoomLayout: true, sidebar: { category: 'reports', route_name: 'DailySales' } },
          },
          {
            path: 'monthly-sales',
            name: 'MonthlySales',
            component: () => import('src/pages/Report/MonthlySales/MonthlySales.vue'),
            meta: { access: [31], useNoZoomLayout: true, sidebar: { category: 'reports', route_name: 'MonthlySales' } },
          },
          {
            path: 'kitchen-efficiency',
            name: 'ReportKitchenEfficiency',
            component: () => import('src/pages/Report/KitchenEfficiency/KitchenEfficiency.vue'),
            meta: {
              access: [26],
              useNoZoomLayout: true,
              sidebar: { category: 'reports', route_name: 'ReportKitchenEfficiency' },
            },
          },
          {
            path: 'sales-by-item',
            name: 'SalesByItem',
            component: () => import('src/pages/Report/SalesByItem/SalesByItem.vue'),
            meta: { access: [15], useNoZoomLayout: true, sidebar: { category: 'reports', route_name: 'SalesByItem' } },
          },
          {
            path: 'item-hourly-sales',
            name: 'ItemHourlySales',
            component: () => import('src/pages/Report/ItemHourlySales/ItemHourlySales.vue'),
            meta: {
              access: [42],
              useNoZoomLayout: true,
              sidebar: { category: 'reports', route_name: 'ItemHourlySales' },
            },
          },
          {
            path: 'sales-by-categories',
            name: 'SalesByCategories',
            component: () => import('src/pages/Report/SalesByCategories/SalesByCategories.vue'),
            meta: {
              access: [21],
              useNoZoomLayout: true,
              sidebar: { category: 'reports', route_name: 'SalesByCategories' },
            },
          },
          {
            path: 'sales-by-modifiers',
            name: 'SalesByModifiers',
            component: () => import('src/pages/Report/SalesByModifiers/SalesByModifiers.vue'),
            meta: {
              access: [38],
              useNoZoomLayout: true,
              sidebar: { category: 'reports', route_name: 'SalesByModifiers' },
            },
          },
          {
            path: 'sales-by-store',
            name: 'SalesByStore',
            component: () => import('src/pages/Report/SalesByStore/SalesByStore.vue'),
            meta: { access: [23], useNoZoomLayout: true, sidebar: { category: 'reports', route_name: 'SalesByStore' } },
          },
          {
            path: 'sales-by-branch',
            name: 'SalesByBranch',
            component: () => import('src/pages/Report/SalesByBranch/SalesByBranch.vue'),
            meta: {
              access: [24],
              useNoZoomLayout: true,
              sidebar: { category: 'reports', route_name: 'SalesByBranch' },
            },
          },
          {
            path: 'sales-by-condition',
            name: 'SalesByCondition',
            component: () => import('src/pages/Report/SalesByCondition/SalesByCondition.vue'),
            meta: {
              access: [22],
              useNoZoomLayout: true,
              sidebar: { category: 'reports', route_name: 'SalesByCondition' },
            },
          },
          {
            path: 'sales-by-payment',
            name: 'SalesByPayment',
            component: () => import('src/pages/Report/SalesByPayment/SalesByPayment.vue'),
            meta: {
              access: [34],
              useNoZoomLayout: true,
              sidebar: { category: 'reports', route_name: 'SalesByPayment' },
            },
          },
          {
            path: 'applied-promotions',
            name: 'AppliedPromotions',
            component: () => import('src/pages/Report/AppliedPromotions/AppliedPromotions.vue'),
            meta: {
              access: [32],
              useNoZoomLayout: true,
              sidebar: { category: 'reports', route_name: 'AppliedPromotions' },
            },
          },
          {
            path: 'sales-compare',
            name: 'SalesCompare',
            component: () => import('src/pages/Report/SalesCompare/SalesCompare.vue'),
            meta: { access: [30], useNoZoomLayout: true, sidebar: { category: 'reports', route_name: 'SalesCompare' } },
          },
          {
            path: 'transactions',
            name: 'TransactionsReport',
            component: () => import('src/pages/Report/Transactions/Transactions.vue'),
            meta: {
              access: [25],
              useNoZoomLayout: true,
              sidebar: { category: 'reports', route_name: 'TransactionsReport' },
            },
          },
          {
            path: 'item-transactions',
            name: 'ItemTransactions',
            component: () => import('src/pages/Report/ItemTransactions/ItemTransactions.vue'),
            // TODO: Fix the access code
            meta: {
              access: [25],
              useNoZoomLayout: true,
              sidebar: { category: 'reports', route_name: 'ItemTransactions' },
            },
          },
          {
            path: 'sales-tax',
            name: 'SalesTaxReport',
            component: () => import('src/pages/Report/SalesTaxReport/SalesTaxReport.vue'),
            meta: {
              access: [33],
              useNoZoomLayout: true,
              sidebar: { category: 'reports', route_name: 'SalesTaxReport' },
            },
          },
          {
            path: 'sales-tip',
            name: 'SalesTipReport',
            component: () => import('src/pages/Report/SalesTipReport/SalesTipReport.vue'),
            meta: {
              access: [39],
              useNoZoomLayout: true,
              sidebar: { category: 'reports', route_name: 'SalesTipReport' },
            },
          },
          {
            path: 'sales-refund',
            name: 'SalesRefundReport',
            component: () => import('src/pages/Report/SalesRefundReport/SalesRefundReport.vue'),
            meta: {
              access: [41],
              useNoZoomLayout: true,
              sidebar: { category: 'reports', route_name: 'SalesRefundReport' },
            },
          },
          {
            path: 'stock-level',
            name: 'StockLevelReport',
            component: () => import('src/pages/Report/StockLevel/StockLevel.vue'),
            meta: {
              access: [28],
              useNoZoomLayout: true,
              sidebar: { category: 'reports', route_name: 'StockLevelReport' },
            },
          },
          {
            path: 'item-margin',
            name: 'ItemMargin',
            component: () => import('src/pages/Report/ItemMargin/ItemMargin.vue'),
            meta: { access: [27], useNoZoomLayout: true, sidebar: { category: 'reports', route_name: 'ItemMargin' } },
          },
          {
            path: 'balance-sheet',
            name: 'BalanceSheet',
            component: () => import('src/pages/Report/BalanceSheet/BalanceSheet.vue'),
            meta: {
              access: [14],
              useNoZoomLayout: true,
              sidebar: { category: 'accounting', route_name: 'BalanceSheet' },
            },
          },
          {
            path: 'embargo-pay-reports',
            name: 'EmbargoPayReport',
            component: () => import('src/pages/Report/EmbargoPay/EmbargoPayReport.vue'),
            meta: {
              access: [14],
              useNoZoomLayout: true,
              sidebar: { category: 'reports', route_name: 'EmbargoPayReport' },
            },
          },
        ],
      },

      /* ---------------------------------- Mock ---------------------------------- */
      {
        path: 'mock',
        children: [
          {
            path: 'one',
            name: 'MockOne',
            component: () => import('pages/Mock/MockOne.vue'),
          },
          {
            path: 'two',
            name: 'MockTwo',
            component: () => import('pages/Mock/MockTwo.vue'),
            props: true,
          },
          {
            path: 'mock-setting',
            name: 'MockSetting',
            component: () => import('pages/Mock/MockSetting.vue'),
          },
        ],
      },
      /* -------------------------------------------------------------------------- */
    ],
  },

  /* -------------------------------------------------------------------------- */
  /*                                Clean Layout                                */
  /* -------------------------------------------------------------------------- */
  {
    path: '/auth',
    name: 'Auth',
    // component: () => import("layouts/CleanLayout.vue"),
    component: () => import('layouts/CleanLayout.vue'),
    children: [
      {
        path: 'signup',
        name: 'SignUp',
        component: () => import('pages/Auth/Signup/SignUp.vue'),
      },
      {
        path: 'activation',
        name: 'Activation',
        component: () => import('pages/Auth/Activation/Activation.vue'),
      },
      {
        path: 'security-setup',
        name: 'SecuritySetup',
        component: () => import('pages/Auth/SecuritySetup/SecuritySetup.vue'),
      },
      {
        path: 'login',
        name: 'Login',
        component: () => import('pages/Auth/Login/Login.vue'),
      },
      {
        path: 'forgotten-password',
        name: 'Forgotten',
        component: () => import('pages/Auth/Forgotten/Forgotten.vue'),
      },
      {
        path: 'forgotten-password/verify',
        name: 'ForgottenVerify',
        component: () => import('pages/Auth/ForgottenVerify/ForgottenVerify.vue'),
      },
      {
        path: 'reset-password',
        name: 'ResetPassword',
        component: () => import('pages/Auth/ResetPassword/ResetPassword.vue'),
      },
    ],
  },

  {
    path: '/digital-menu',
    // component: () => import("layouts/CleanLayout.vue"),
    component: () => import('layouts/CleanLayout.vue'),
    children: [
      {
        path: 'signin',
        name: 'DigitalMenuLogin',
        component: () => import('src/pages/DigitalMenu/DigitalMenuLogin/DigitalMenuLogin.vue'),
      },
      {
        path: 'licence',
        name: 'DigitalMenuLicence',
        component: () => import('src/pages/DigitalMenu/DigitalMenuLicence/DigitalMenuLicence.vue'),
      },
    ],
  },

  {
    path: '/partner',
    name: 'Partner',
    component: () => import('layouts/CleanLayout.vue'),
    children: [
      {
        path: 'entrance',
        name: 'Entrance',
        component: () => import('pages/Partner/Entrance/Entrance.vue'),
        props: true,
      },
    ],
  },

  // Always leave this as last one,
  // but you can also remove it
  {
    path: '/:catchAll(.*)*',
    component: () => import('pages/ErrorNotFound.vue'),
  },
]

export default routes
